/**
 * Optional absolute API origin for local dev (e.g. http://localhost:5001).
 * Set REACT_APP_API_ORIGIN in .env.local when the CRA proxy does not forward /api correctly.
 */
export function apiUrl(path) {
  const base = (process.env.REACT_APP_API_ORIGIN || '').replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base}${p}` : p;
}
